module.exports = __webpack_public_path__ + "img/no-results-03.0571e950.webp";